// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { useRef } from 'react';
import { FormattedMessage } from 'react-intl';

import Dialog from '../../../components/Dialog';
import { S } from '../LabPageStyle';

interface LabTimeUpDialogProps {
  showDialog: boolean;
  closeDialog: () => void;
}

const LabTimeUpDialog = ({ showDialog, closeDialog }:LabTimeUpDialogProps):JSX.Element => {
  const dialogRef = useRef<HTMLDivElement>(null);

  return (
    <Dialog showDialog={showDialog}>
      <S.EndLabContainer ref={dialogRef}>
        <S.EndLabIcon />
        <S.EndLabTitle><FormattedMessage id="E023" /></S.EndLabTitle>
        <S.EndLabText>
          <FormattedMessage id="E024" values={{ br: <br/> }} />
        </S.EndLabText>
        <S.EndLabButton onClick={closeDialog}><FormattedMessage id="E025" /></S.EndLabButton>
      </S.EndLabContainer>
    </Dialog>
  )
}

export default LabTimeUpDialog;
